export default "__VITE_ASSET__D7$Fo4hr__"